//@ts-nocheck
import styles from './liquid-glass-filter.module.css'

export default function LiquidGlassFilter({moving = false, children}) {
  return (
    <>
      <div className={styles["liquidGlass-wrapper"]}>
        <div className={styles["liquidGlass-effect"]}></div>
        <div className={styles["liquidGlass-tint"]}></div>
        <div className={styles["liquidGlass-shine"]}></div>
        <div className={styles["liquidGlass-text"]}>
          {children}
        </div>
      </div>
      <svg style={{ display: 'none' }} xmlns="http://www.w3.org/2000/svg">
        <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
        >
          {/* Noise source */}
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.0004 0.0009"
            numOctaves="3"
            seed="2"
            result="turbulence"
          />

          {/* Map turbulence values */}
          <feComponentTransfer in="turbulence" result="mapped">
            <feFuncR type="gamma" amplitude="1" exponent="1" offset="0.5" />
            <feFuncG type="gamma" amplitude="1" exponent="1" offset="0" />
            <feFuncB type="gamma" amplitude="1" exponent="1" offset="0.5" />
          </feComponentTransfer>

          {/* Lighting for extra depth */}
          <feSpecularLighting
            in="mapped"
            surfaceScale="30"
            specularConstant="0.7"
            specularExponent="50"
            lightingColor="white"
            result="specLight"
          >
            <fePointLight x="-150" y="-150" z="600" />
          </feSpecularLighting>

          {/* Composite lit result */}
          <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
          />

          <feMorphology
            in="litImage"
            operator={moving ? 'erode' : 'dilate'} //flip when circulat or not
            radius={moving ? '12' : '5'}
            result="expandedLitImage"
          />

          {/* Soften the displacement map */}
          <feGaussianBlur
            in="expandedLitImage"
            stdDeviation="5"
            result="blurredLitImage"
          />

          {/* Final displacement */}
          <feDisplacementMap
            in="SourceGraphic"
            in2="blurredLitImage"
            scale="10"
            xChannelSelector="A"
            yChannelSelector="A"
          />
        </filter>
      </svg>
    </>
    
  );
}
